import React from 'react';
import TinyExploitDetection from 'views/tiny/TinyExploitDetection.js';

function TinyExploitDetectionContainer() {
  return <TinyExploitDetection />;
}

export default TinyExploitDetectionContainer;
